import type {
  PrototypeLineupCandidate,
  PrototypeLineupDecision,
} from "../prototype/types.js";

export interface LineupCandidateView {
  readonly candidateId: string;
  readonly playerName: string;
  readonly gameLabel: string;
  readonly melbourneTip: string;
  readonly ruleVersion?: string;
  readonly units?: number;
  readonly recommendation?: PrototypeLineupCandidate["recommendation"];
}

export function LineupQueue({
  candidates = [],
  onDecision = () => undefined,
}: {
  candidates?: readonly LineupCandidateView[];
  onDecision?: (candidateId: string, status: PrototypeLineupDecision) => void;
}) {
  return (
    <section className="lineup card">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">Manual gate</span>
          <h3>Lineup queue</h3>
        </div>
        <span className="count-badge">{candidates.length}</span>
      </div>
      {candidates.length === 0 ? (
        <p className="lineup-empty">No manual confirmations waiting.</p>
      ) : (
        candidates.map((candidate) => (
          <article className="lineup-item pending" key={candidate.candidateId}>
            <div className="lineup-meta">
              <strong>{candidate.playerName}</strong>
              <span>{candidate.gameLabel}</span>
              <span>{candidate.melbourneTip}</span>
            </div>
            <p>
              Confirm non-starter status before{" "}
              {candidate.ruleVersion ?? candidate.recommendation?.ruleVersion}{" "}
              can release {candidate.units ?? candidate.recommendation?.units}u.
            </p>
            <div className="lineup-actions">
              <button
                className="button secondary compact"
                type="button"
                onClick={() =>
                  onDecision(candidate.candidateId, "CONFIRMED_STARTER")
                }
              >
                Starter
              </button>
              <button
                className="button primary compact"
                type="button"
                onClick={() =>
                  onDecision(candidate.candidateId, "CONFIRMED_NON_STARTER")
                }
              >
                Non-starter
              </button>
            </div>
          </article>
        ))
      )}
    </section>
  );
}
